import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Spinner, Row, Col } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PieChart from "components/shared/Charts/PieChart";
import { RepositoryFactory } from "repository/RepositoryFactory";

const Stats = RepositoryFactory.get("stats");

const RevenueEarned = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const { user } = useSelector((state) => state.auth);
  const { restaurantCurrency } = useSelector((state) => state.requests);
  const [revenueValue, setRevenueValue] = useState();

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : "",
  };

  const {
    data: latestRevenueEarned,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ["revenueEarned", payload],
    queryFn: async () => {
      const { data } = await Stats.getRevenueEarned(payload);
      return data?.data;
    },
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true,
  });

  if (isError) {
    toast.error(error?.message || "Failed to load revenue earned.");
  }

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const labels =
    latestRevenueEarned?.items?.map((item) => capitalize(item.name)) || [];
  const series =
    latestRevenueEarned?.items?.map((item) => parseFloat(item.revenue)) || [];

  const chartOptions = {
    chart: { type: "pie" },
    labels,
    legend: { fontFamily: "Poppins, sans-serif" },
    dataLabels: {
      enabled: true,
    },
    tooltip: { enabled: true },
  };

  useEffect(() => {
    setRevenueValue(latestRevenueEarned?.totalRevenue);
  }, latestRevenueEarned);

  return (
    <Row>
      <Col md={12}>
        <Card className="header-cards card overflow-hidden">
          <CardHeader className="d-flex justify-content-between flex-column flex-sm-row">
            <h3 className="mb-0">Revenue Earned</h3>
            <h2 className="mb-0 ml-sm-3">
              {restaurantCurrency || "$"}
              {revenueValue || 0}
            </h2>
          </CardHeader>
          {isFetching ? (
            <Spinner size="sm" color="primary" className="mx-auto my-5" />
          ) : (
            <CardBody className="d-flex justify-content-center align-items-center">
              <PieChart
                chartOptions={chartOptions}
                chartSeries={series}
                type="pie"
                prefix="$"
              />
            </CardBody>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default RevenueEarned;
